// extracted by mini-css-extract-plugin
export default {"wrapper":"TextInput_wrapper__l12y2","label":"TextInput_label__XRdL9","inputtext":"TextInput_inputtext__xyiYn"};